import React, { useEffect, useState, useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { GlobalContext } from '../../Contexts/GlobalContext';
import {useHistory} from 'react-router-dom';

export default function AdvancedSettingBox(props) {
    const globalContext = useContext(GlobalContext);
    const classes = useStyles();
    const history = useHistory();

    const goToUrl = (url) => {
        history.push(url);
    }

    return (
        <div className={classes.setting} onClick={()=>goToUrl(props.url)}>
            <div className={classes.settingLeft}>
                <i className="material-icons">{props.icon}</i>
            </div>
            <div className={classes.settingRight}>
                <div className={classes.settingRightUp}>
                    {props.name}
                </div>
                <div className={classes.settingRightDown}>
                    {props.description}
                </div>
            </div>
        </div>
    )
}

const useStyles = makeStyles({
    setting: {
        display: 'flex',
        minWidth: '300px',
        maxWidth: '90%',
        marginBottom: '20px',
        '&>div': {
            padding: '10px',
        },
        cursor: 'pointer',
    },
    settingRightUp: {
        color: '#008ae4',
        fontWeight: 500,
    },
    settingRightDown: {
        paddingTop: '10px',
        color: 'gray',
        //paddingLeft: '10px',
        maxWidth: '280px',
        fontSize: '0.8rem',
    },
});